import api from '../api';

const state = {
    data: {},
    meta: {}
};

const actions = {
    init: async ({}, data) => {
        return api.post('/api/v1/edit_mode', data).catch((error) => {
            console.error(error);
            return Promise.reject(error);
        });
    },

    get: async ({}, data) => {
        return api.get(`/api/v1/edit_mode?page=${data.page}`);
    }
};

const mutations = {};

const getters = {
    getById: (state) => (page) => {
        return state.data.find((item) => item.page === page);
    },
    getMeta: (state) => {
        return state.meta;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
